import axios from "axios";
import { apiPath } from "../config";
import Toast from "../Components/Toastify/Toastify";

const CancelToken = axios.CancelToken;
let source = CancelToken.source();

axios.interceptors.request.use(
  function (config) {
    const cancelToken = source.token;
    // console.log({ config, cancelToken });
    // Do something before request is sent
    return { ...config, cancelToken };
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    // console.log({ response });
    // if (response.data.success) {
    //   source.cancel("fired");

    //   setTimeout(() => {
    //     source = CancelToken.source();
    //   }, 1000);
    // }
    // Toast.error("asdiajsdoiajsdoi");
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error

    // console.log({ error });
    return Promise.reject(error);
  }
);

const post = ({
  url = "",
  body = {},
  headers = {},
  queryParams = {},
  otherConfigs = {},
}) => {
  return axios.post(apiPath + url, body, {
    headers,
    params: queryParams,
    ...otherConfigs,
  });
};

const put = ({
  url = "",
  body = {},
  headers = {},
  queryParams = {},
  otherConfigs = {},
}) => {
  return axios.put(apiPath + url, body, {
    headers,
    params: queryParams,
    ...otherConfigs,
  });
};

const get = ({
  url = "",
  headers = {},
  queryParams = {},
  otherConfigs = {},
}) => {
  headers["ngrok-skip-browser-warning"] = 1;
  return axios.get(apiPath + url, {
    headers,
    params: queryParams,
    ...otherConfigs,
  });
};

const deleteRequest = ({
  url = "",
  headers = {},
  queryParams = {},
  otherConfigs = {},
}) => {
  return axios.delete(apiPath + url, {
    headers,
    params: queryParams,
    ...otherConfigs,
  });
};

export default {
  get,
  post,
  put,
  delete: deleteRequest,
};
